import { openBlock as e, createElementBlock as l, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}, n = /* @__PURE__ */ o("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.503 4.444a2.785 2.785 0 0 1 2.79-2.777 2.784 2.784 0 0 1 2.79 2.777 2.785 2.785 0 0 1-2.79 2.779 2.8 2.8 0 0 1-1.987-.829l-3.862 2.63a2.8 2.8 0 0 1-.152 1.598l4.235 2.783a2.8 2.8 0 0 1 1.767-.627 2.786 2.786 0 0 1 2.79 2.778 2.785 2.785 0 0 1-2.791 2.777 2.784 2.784 0 0 1-2.79-2.777c0-.39.081-.775.24-1.13l-4.201-2.76a2.8 2.8 0 0 1-1.835.685 2.784 2.784 0 0 1-2.79-2.778 2.784 2.784 0 0 1 2.79-2.778c.887 0 1.675.41 2.186 1.05l3.744-2.548a2.8 2.8 0 0 1-.134-.853",
  "clip-rule": "evenodd"
}, null, -1), r = [
  n
];
function c(d, a) {
  return e(), l("svg", t, [...r]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
